module.exports = __webpack_public_path__ + "static/two-children-kissing-their-mother-on-the-cheek-mobile.00f10028.webp";